/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Delete_LabelInputs */



/**
* | output |
* | --- |
* | "Delete issue" |
*
* @param {Manual_Qc_Delete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_delete_label = /** @type {((inputs?: Manual_Qc_Delete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Delete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить проблему")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir problema")
	return /** @type {LocalizedString} */ ("Delete issue")
});